import styled from '@emotion/styled';
import { Spacings, mobile } from '../../../styleConstants';

const ContentContainer = styled.div`
  width: 1136px;
  margin-left: auto;
  margin-right: auto;
  @media only screen and (max-width: ${mobile.maxWidth}) {
    width: calc(100vw - ${Spacings.SPACING_10B});
  }
`;

export default ContentContainer;
